'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var ChatBubble_module = require('./ChatBubble.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const ChatBubble = ({
  author,
  children
}) => {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: clsx__default["default"]({
      [ChatBubble_module["default"].bubbleContainer]: true,
      [ChatBubble_module["default"].narvarUser]: author === 'NARVAR'
    })
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: clsx__default["default"]({
      [ChatBubble_module["default"].chatBubble]: true,
      [ChatBubble_module["default"].narvarUser]: author === 'NARVAR'
    })
  }, children));
};

exports["default"] = ChatBubble;
